import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

let cached: { app: FirebaseApp; auth: Auth } | null = null;

export function getFirebase() {
  if (cached) return cached;
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };
  if (!config.apiKey) throw new Error('Firebase config missing: set VITE_FIREBASE_* in .env');
  const app = initializeApp(config);
  const auth = getAuth(app);
  cached = { app, auth };
  return cached;
}
